var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('arrow-left',{staticClass:"itserve-menu-icon",attrs:{"fill-color":_vm.appTheme === 'dark' ? '#0562ad' : '#ffffff'},on:{"click":_vm.goBack}})}
var staticRenderFns = []

export { render, staticRenderFns }